import { ICoordPair } from "@/modules/ToolModule/TwoPointsPicker";
import { V3 } from "@/utils/math";
import { EquatorialCoord } from "@hscmap/stellar-globe";
import { mat3, vec3 } from "gl-matrix";

// test the triangle "VA", "VB" and "VC" intersects with line "l"
export function intersect(line: ICoordPair, VA: V3, VB: V3, VC: V3) {
  const Q = line.c0.xyz
  const P = line.c1.xyz
  const A = mat3.fromValues(VA[0], VA[1], VA[2], VB[0], VB[1], VB[2], VC[0], VC[1], VC[2])
  const B = mat3.invert(mat3.create(), A)!
  const B0 = [B[0], B[3], B[6]] as any
  const B1 = [B[1], B[4], B[7]] as any
  const B2 = [B[2], B[5], B[8]] as any
  const D = vec3.sub(vec3.create(), P, Q)
  const a = zeroOneRange(vec3.dot(B0, D), vec3.dot(B0, Q))
  const b = zeroOneRange(vec3.dot(B1, D), vec3.dot(B1, Q))
  const c = zeroOneRange(vec3.dot(B2, D), vec3.dot(B2, Q))
  const range = a.intersect(b).intersect(c)
  return range.valid() && new Range(0, 1).intersect(range).valid()
}

function zeroOneRange(a: number, b: number) {
  const x0 = (0 - b) / a
  const x1 = (1 - b) / a
  return new Range(Math.min(x0, x1), Math.max(x0, x1))
}

class Range {
  constructor(readonly a: number, readonly b: number) { }

  intersect(other: Range) {
    return new Range(
      Math.max(this.a, other.a),
      Math.min(this.b, other.b))
  }

  valid() {
    return this.a <= this.b
  }
}
